function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M170.717 155.948c0 4.333 5.477 7.846 12.233 7.846s12.234-3.513 12.234-7.846-5.478-7.846-12.234-7.846-12.233 3.513-12.233 7.846",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M173.115 157.318c0 4.333 5.478 7.847 12.233 7.847 6.757 0 12.234-3.514 12.234-7.847s-5.477-7.846-12.234-7.846c-6.755 0-12.233 3.513-12.233 7.846z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M173.115 157.318v7.256c0 4.333 5.478 7.846 12.233 7.846 6.757 0 12.234-3.513 12.234-7.846v-7.256",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  fill: "#FFF",
  d: "M153.32 104.021h35.602V89H153.32z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M206.667 145.658l4.144-5.04-6.247-12.972m5.18 10.539l3.949-5.254-6.726-9.61"
}), React.createElement("path", {
  d: "M212.271 130.934l2.143-7.972-27.747-13.694s-1.8-.6-2.042-3.362l-27.267.03s-2.28 4.653-2.28 18.106c0 20.023 12.252 23.374 12.732 35.434 0 0 5.343-.655 5.343-9.423 0-6.538-3.422-8.113-3.422-8.113s3.003-5.886 14.054-5.886c11.05 0 16.575 10.69 16.575 10.69s-3.362 9.608-.6 15.135l8.047-12.972-5.765-15.256m-48.722-27.749h35.602V90.881H153.32zm32.937 155.931l-50.638-38.554 48.645-37.036 50.638 38.554z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M234.901 243.401l-48.645 37.036-50.637-38.554m99.282-17.086v18.604m-99.282-20.121v18.604m50.638 19.949v19.162"
}), React.createElement("path", {
  d: "M206.912 208.15s-12.202 8.814-11.76 8.814l13.635 10.344-1.875-19.158z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M208.55 209.378s-12.203 8.814-11.761 8.814l13.636 10.344-1.875-19.158z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M210.425 228.536v5.8l-13.636-10.344v-5.8 4.13"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M150.382 220.268l8.4 6.51 10.042-7.35-8.386-6.582z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M152.003 220.268l8.4 6.51 10.043-7.35-8.387-6.582zm18.679-.779l.013 5.37c-.059.027-10.16 7.38-10.16 7.38"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M151.776 220.179v5.242l8.628 6.6v-5.285"
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M175.116 242.563l-.966-7.039 8.005-4.14 10.351 2.761.827 6.486-7.314 5.404z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M176.726 242.931l-.412-7.038 7.45-4.14 10.351 2.76.828 6.486-7.315 5.692z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M194.945 240.906v5.337l-7.178 5.692-10.903-3.759-.138-5.245m10.903 3.759l.139 5.245"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 370 370",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide_2.svg